var script = {
  name: "mgraph-component",

  data() {
    return {
      graph: null
    };
  },

  created() {
    let element = this;

    while (element && element.$options && element.$options.name != "mgraph") {
      element = element.$parent;
    }

    this.graph = element;
  }

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

//

function clamp(min, x, max) {
  return x < min ? min : x > max ? max : x;
}

const ticks = [{
  major: 5,
  minors: 5
}, {
  major: 2,
  minors: 4
}, {
  major: 1,
  minors: 5
}, {
  major: 0.5,
  minors: 5
}, {
  major: 0.2,
  minors: 4
}, {
  major: 0.1,
  minors: 5
}];
var script$1 = {
  mixins: [__vue_component__],
  name: "mgraph-axis",
  props: {
    axis: {
      type: String,
      default: "x",
      validator: value => {
        return value == "x" || value == "y";
      }
    },
    tickLabels: {
      type: Boolean,
      default: true
    },
    ticks: {
      default: "auto"
    },
    minorTicks: {
      default: 1,
      type: Number
    }
  },
  computed: {
    range() {
      const graph = this.graph;
      return graph[this.axis + "Range"];
    },

    position() {
      const graph = this.graph;
      let [x, y] = graph.transform(0, 0);
      if (this.axis == "x") return clamp(10, y, graph.height - 10);else return clamp(10, x, graph.width - 10);
    },

    shiftLabelsPositive() {
      return this.axis == "x" ? this.position < this.graph.height / 2 : this.position < this.graph.width / 2;
    },

    textAnchor() {
      return this.axis == "x" ? "middle" : this.shiftLabelsPositive ? "start" : "end";
    },

    alignmentBaseline() {
      return this.axis == "x" ? this.shiftLabelsPositive ? "hanging" : "baseline" : "middle";
    },

    allTicks() {
      if (this.ticks == "auto") {
        const [min, max] = this.range;
        let scale = 1;
        const distance = max - min;

        while (distance / scale > 20) scale *= 10;

        while (distance / scale < 2) scale /= 10;

        const majorTicks = 5;
        let bestTick = null;

        for (const tick of ticks) {
          if (bestTick == null || Math.abs(distance / (scale * tick.major) - majorTicks) < Math.abs(distance / (scale * bestTick.major) - majorTicks)) bestTick = tick;
        }

        const step = scale * bestTick.major;
        const axisTicks = [];

        for (let i = Math.floor(min / step) * step; i < max; i += step) {
          const label = Math.round(i / scale * 10) * scale / 10;
          axisTicks.push({
            value: i,
            label: label == "0" ? "" : label,
            major: true
          });

          for (let j = 1; j < bestTick.minors; ++j) {
            const value = i + step * j / bestTick.minors;
            axisTicks.push({
              value: value,
              label: Math.round(value / scale * 10) * scale / 10,
              major: false
            });
          }
        }

        return axisTicks;
      } else {
        const axisTicks = [];
        const ticks = this.ticks;
        const minorTicks = this.minorTicks;

        for (let i = 0; i < ticks.length; ++i) {
          axisTicks.push({
            value: ticks[i],
            label: "" + ticks[i],
            major: true
          });

          if (i > 0 && minorTicks > 1) {
            for (let j = 1; j < minorTicks; ++j) {
              axisTicks.push({
                value: ticks[i - 1] + j * (ticks[i] - ticks[i - 1]) / minorTicks,
                label: "",
                major: false
              });
            }
          }
        }

        return axisTicks;
      }
    },

    majorTickLabels() {
      const graph = this.graph;
      const position = this.position;
      const shiftUp = this.shiftLabelsPositive;
      return this.allTicks.filter(t => t.major).map(this.axis == "x" ? ({
        value,
        label
      }) => {
        const [x] = graph.transform(value, 0);
        return {
          x,
          y: position + (shiftUp ? 10 : -10),
          label
        };
      } : ({
        value,
        label
      }) => {
        const [, y] = graph.transform(0, value);
        return {
          x: position + (shiftUp ? 10 : -10),
          y,
          label
        };
      });
    },

    path() {
      const graph = this.graph;
      const width = graph.width;
      const height = graph.height;
      const position = this.position;

      if (this.axis == "x") {
        let path = `M 0 ${position} l ${width} 0`;

        for (const {
          value,
          major
        } of this.allTicks) {
          const size = major ? 8 : 5;
          const [x] = graph.transform(value, 0);
          path += `M ${x} ${position - size} l 0 ${2 * size}`;
        }

        return path;
      } else {
        let path = `M ${position} 0 l 0 ${height}`;

        for (const {
          value,
          major
        } of this.allTicks) {
          const size = major ? 8 : 5;
          const [, y] = graph.transform(0, value);
          path += `M ${position - size} ${y} l ${2 * size} 0`;
        }

        return path;
      }
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('g', [_c('path', {
    attrs: {
      "d": _vm.path,
      "stroke": "black",
      "stroke-width": "3"
    }
  }), _vm.tickLabels ? _c('g', _vm._l(_vm.majorTickLabels, function (tick) {
    return _c('text', {
      attrs: {
        "x": tick.x,
        "y": tick.y,
        "text-anchor": _vm.textAnchor,
        "dominant-baseline": _vm.alignmentBaseline
      }
    }, [_vm._v(_vm._s(tick.label))]);
  }), 0) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
var script$2 = {
  name: "mgraph",
  components: {
    "svg-axis": __vue_component__$1
  },
  props: {
    xRange: {
      type: Array,
      default: () => [-1.05, 1.05],

      validator([x, y]) {
        return !isNaN(x) && !isNaN(y) && x < y;
      }

    },
    yRange: {
      type: Array,
      default: () => [-1.05, 1.05],

      validator([x, y]) {
        return !isNaN(x) && !isNaN(y) && x < y;
      }

    },
    aspectRatio: {
      type: Number,
      default: () => 1
    }
  },

  data() {
    return {
      width: 200,
      height: 200
    };
  },

  mounted() {
    this.resizer();
  },

  destroyed() {
    window.removeEventListener("resize", this.resizer);
  },

  created() {
    this.resizer = () => this.resize();

    window.addEventListener("resize", this.resizer);
  },

  methods: {
    resize() {
      this.width = this.$refs.root.clientWidth;
      const [xmin, xmax] = this.xRange;
      const [ymin, ymax] = this.yRange;
      this.height = (ymax - ymin) / (xmax - xmin) * this.width / this.aspectRatio;
    },

    transform(x, y) {
      const [xmin, xmax] = this.xRange;
      const [ymin, ymax] = this.yRange;
      return [(x - xmin) * this.width / (xmax - xmin), (ymax - y) * this.height / (ymax - ymin)];
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    ref: "root",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
var script$3 = {
  mixins: [__vue_component__],
  name: "mgraph-path",
  props: {
    points: Array,
    closed: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    path() {
      const graph = this.graph;
      const points = this.points.map(([x, y]) => graph.transform(x, y)).filter(([x, y]) => !isNaN(x) && !isNaN(y));
      if (points.length < 2) return "";
      let [x, y] = points[0];
      let path = `M ${x} ${y}`;

      for (let i = 1; i < points.length; ++i) {
        [x, y] = points[i];
        path += ` L ${x} ${y}`;
      }

      if (this.closed) path += "Z";
      return path;
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('path', {
    attrs: {
      "d": _vm.path
    }
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
var script$4 = {
  mixins: [__vue_component__],
  name: "mgraph-point",
  props: {
    xy: Array,
    x: [String, Number],
    y: [String, Number],
    r: {
      type: [Number, String],
      default: 5
    }
  },
  computed: {
    position() {
      return this.graph.transform(this.x === undefined ? this.xy[0] : +this.x, this.y === undefined ? this.xy[1] : +this.y);
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('circle', {
    attrs: {
      "cx": _vm.position[0] || 0,
      "cy": _vm.position[1] || 0,
      "r": _vm.r
    }
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

//
var script$5 = {
  mixins: [__vue_component__],
  name: "mgraph-field",
  props: {
    f: Function,
    n: {
      default: () => [20, 20]
    },
    xRange: {
      default: null
    },
    yRange: {
      default: null
    }
  },
  computed: {
    field() {
      const lines = [];
      const [xmin, xmax] = this.xRange || this.graph.xRange;
      const [ymin, ymax] = this.yRange || this.graph.yRange;
      const n = this.n;
      const [nx, ny] = +n === n ? [n, n] : n;

      const f = this.f || (() => 0);

      const graph = this.graph;
      const size = Math.min(graph.width, graph.height) / (3 * n[0]);

      for (let i = 0.5; i < nx; ++i) for (let j = 0.5; j < ny; ++j) {
        const t = xmin + (xmax - xmin) * i / nx;
        const y = ymin + (ymax - ymin) * j / ny;
        const [xc, yc] = graph.transform(t, y);
        let [dx, dy] = graph.transform(t + 1, y + f(t, y));
        dx -= xc;
        dy -= yc;
        const scale = size / Math.hypot(dx, dy);
        dx *= scale;
        dy *= scale;
        lines.push([[xc - dx, yc - dy], [xc + dx, yc + dy]]);
      }

      return lines;
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('g', {
    staticClass: "ode-field"
  }, _vm._l(_vm.field, function (line) {
    return _c('line', {
      staticStyle: {
        "stroke": "red",
        "stroke-width": "1"
      },
      attrs: {
        "x1": line[0][0] || 0,
        "y1": line[0][1] || 0,
        "x2": line[1][0] || 0,
        "y2": line[1][1] || 0
      }
    });
  }), 0);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$6 = {
  mixins: [__vue_component__],
  name: "mgraph-text",
  props: {
    xy: Array,
    x: [String, Number],
    y: [String, Number]
  },
  computed: {
    position() {
      return this.graph.transform(this.x === undefined ? this.xy[0] : +this.x, this.y === undefined ? this.xy[1] : +this.y);
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('text', {
    attrs: {
      "x": _vm.position[0] || 0,
      "y": _vm.position[1] || 0
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$7 = {
  mixins: [__vue_component__],
  components: {
    "mgraph-path": __vue_component__$3
  },
  name: "mgraph-function",
  props: {
    f: Function,
    numPoints: {
      type: Number,
      default: 200
    }
  },
  computed: {
    points() {
      const points = [];
      const [xmin, xmax] = this.graph.xRange;

      for (let i = 0; i < this.numPoints; ++i) {
        let t = i - 0.5 + 0.2 * (Math.random() - 0.5);
        t /= this.numPoints - 2;
        const x = xmin + t * (xmax - xmin);
        points.push([x, this.f(x)]);
      }

      return points;
    }

  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('mgraph-path', {
    attrs: {
      "points": _vm.points,
      "fill": "transparent",
      "closed": false
    }
  });
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
var script$8 = {
  mixins: [__vue_component__],
  name: "mgraph-g",
  props: {
    xy: Array,
    x: [Number, String],
    y: [Number, String]
  },
  computed: {
    position() {
      return this.graph.transform(this.x === undefined ? this.xy[0] : +this.x, this.y === undefined ? this.xy[1] : +this.y);
    }

  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('g', {
    attrs: {
      "transform": "translate(" + (_vm.position[0] || 0) + " " + (_vm.position[1] || 0) + ")"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MGraph: __vue_component__$2,
  MGraphComponent: __vue_component__,
  MGraphAxis: __vue_component__$1,
  MGraphPath: __vue_component__$3,
  MGraphPoint: __vue_component__$4,
  MGraphField: __vue_component__$5,
  MGraphText: __vue_component__$6,
  MGraphFunction: __vue_component__$7,
  MGraphGroup: __vue_component__$8
});

// Import vue components

const install = function installMathGraphs(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.entries(components).forEach(([componenName, component]) => {
    Vue.component(component.name, component);
  });
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install on non-es builds, when vue is found

export default plugin;
export { __vue_component__$2 as MGraph, __vue_component__$1 as MGraphAxis, __vue_component__ as MGraphComponent, __vue_component__$5 as MGraphField, __vue_component__$7 as MGraphFunction, __vue_component__$8 as MGraphGroup, __vue_component__$3 as MGraphPath, __vue_component__$4 as MGraphPoint, __vue_component__$6 as MGraphText };
